import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Layout from '../components/layout/Layout';
import { theme } from '../styles/theme';
import { beginLogin, isShopifyConfigured } from '../services/shopifyAuth';
import {
  PageContainer,
  PageTitle,
  Button,
  Alert,
  FormContainer,
} from '../styles/components';

const AuthContainer = styled(PageContainer)`
  max-width: 500px;
`;

const Intro = styled.p`
  text-align: center;
  margin-bottom: ${theme.spacing.lg};
  color: ${theme.colors.lightText};
`;

const LoginPage: React.FC = () => {
  const location = useLocation();
  const [redirecting, setRedirecting] = useState(false);

  // Return to the page that sent the user here, if provided
  const returnTo = (location.state as { from?: string } | null)?.from;

  const handleLogin = async () => {
    setRedirecting(true);
    await beginLogin(returnTo);
  };

  return (
    <Layout>
      <Helmet>
        <title>Logg inn | Tryllepapp</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <AuthContainer>
        <PageTitle>Logg inn</PageTitle>

        {!isShopifyConfigured() && (
          <Alert variant="danger">
            Innlogging er ikke konfigurert. Kontakt oss om problemet vedvarer.
          </Alert>
        )}

        <FormContainer>
          <Intro>
            Logg inn eller opprett konto med Shopify for å se ordrehistorikk og bruke butikkreditt.
          </Intro>
          <Button
            type="button"
            variant="accent"
            fullWidth
            disabled={redirecting || !isShopifyConfigured()}
            onClick={handleLogin}
          >
            {redirecting ? 'Sender deg til Shopify...' : 'Logg inn med Shopify'}
          </Button>
        </FormContainer>
      </AuthContainer>
    </Layout>
  );
};

export default LoginPage;
